import { StrictMode } from "react";
import "./index.css";
import App from "./App.tsx";
import "@mantine/core/styles.css";
import '@mantine/tiptap/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/code-highlight/styles.css';
import '@mantine/dates/styles.css';

import { theme } from "@/theme";
import { MantineProvider } from "@mantine/core";
import { AuthProvider } from "@/contexts/auth.ctx.tsx";
import { ResultsProvider } from "./contexts/results.ctx";
import { TeamProvider } from "./contexts/team.ctx.tsx";
import { CacheManager } from "@/utils/cache.man";
import { ProfileProvider } from "./contexts/profile.ctx";
import { Notifications } from "@mantine/notifications";
import { AppMetaInfo } from "./contexts/app.meta.slg.ts";
import { ConditionalOrganizationProvider } from "./contexts/org.ctx.tsx";

export default function AdminApp() {
  void CacheManager.Instance(); // Just call it to initialize it
  void AppMetaInfo.Instance();
  return (
    <StrictMode>
      <MantineProvider theme={theme} defaultColorScheme="auto">
        <Notifications zIndex={5000} />
        <AuthProvider>
          <ResultsProvider>
            <ProfileProvider>
              <TeamProvider>
                <ConditionalOrganizationProvider>
                  <App />
                </ConditionalOrganizationProvider>
              </TeamProvider>
            </ProfileProvider>
          </ResultsProvider>
        </AuthProvider>
      </MantineProvider>
    </StrictMode>
  )
}
